import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';

import ConnectedOfferPropertiesList from 'containers/OfferPropertiesList';
import {OfferFiltersProperty} from 'models/OfferFilters';
import {OffersActions} from 'store/offers/offers.reducer';
import {
  availableFiltersSelector,
  selectedFilterSelector,
} from 'store/offers/offers.selectors';

import FilterScreenMobile from './FilterScreenMobile';

const HotelsAndResortsMobile = () => {
  const dispatch = useDispatch();
  const selectedFilters = useSelector(selectedFilterSelector);
  const availableFilters = useSelector(availableFiltersSelector);
  const selectedDestination = selectedFilters.destination;
  const selectedProperties = selectedFilters.properties;

  const setSelectedProperties = useCallback(
    (_selectedProperties: OfferFiltersProperty[] | undefined) => {
      dispatch(OffersActions.setSelectedPropertyFilter(_selectedProperties));
    },
    [dispatch]
  );

  // DRY: Same logic exists in components/Offers/Filters/index
  const handleSelectProperty = (item: OfferFiltersProperty) => {
    if (selectedProperties) {
      const position = selectedProperties.indexOf(item);
      // If item exists, delete it from the list
      if (position !== -1) {
        const newProperties = [...selectedProperties];
        newProperties.splice(position, 1);
        setSelectedProperties(newProperties);
      } else {
        // If we've selected all the properties, it's the same as having none selected
        if (
          selectedProperties.length + 1 ===
          availableDestinationProperties?.length
        ) {
          setSelectedProperties([]);
        } else {
          // Add to the list
          setSelectedProperties([...selectedProperties, item]);
        }
      }
    }
  };

  const handleSelectAllProperties = () => setSelectedProperties([]);
  const availableDestinationProperties = selectedDestination?.properties.filter(
    property => availableFilters.properties?.includes(property.id.toUpperCase())
  );

  return (
    <FilterScreenMobile title="HOTELS & RESORTS">
      <ConnectedOfferPropertiesList
        selected={selectedProperties ?? []}
        onSelect={handleSelectProperty}
        properties={selectedFilters.destination?.properties ?? []}
        onSelectAll={handleSelectAllProperties}
        availableProperties={availableFilters.properties}
      />
    </FilterScreenMobile>
  );
};
export default HotelsAndResortsMobile;
